import PropTypes from 'prop-types'
import Badge from 'react-bootstrap/Badge'
import { formatearFecha } from '../../helpers/dateValidation'
import { obtenerEstadoVisual } from '../../helpers/presupuestoEstado.js'
import { useAuth } from '../../hooks/useAuth'
import LinkButton from '../ui/LinkButton'
import styles from './Presupuesto.module.css'

const Presupuesto = ({ presupuesto, esVentas }) => {
  const { loginDataContext: { idUsuario } = {}, esPerfilAdmin } = useAuth()

  const {
    nombreVendedor,
    nombreComprador,
    cantDiasEntrega,
    fechaValidez,
    razonSocial,
    idUsuario: idComprador,
    idVendedor
  } = presupuesto

  const { color: colorEstado, label: labelEstado } = obtenerEstadoVisual(presupuesto)

  const pathDetalle = {
    pathname: `/Presupuesto/${presupuesto.idPresupuesto}`,
    state: { esVentas }
  }

  const muestraNombreNoAdmin =
    esPerfilAdmin && (esVentas ? idVendedor !== idUsuario : idComprador !== idUsuario)

  return (
    <div className={styles.presupuesto}>
      <div className={styles.cabecera}>
        <h3 className={styles.titulo}>{`Presupuesto Nº ${presupuesto.idPresupuesto}`}</h3>
        <Badge bg={colorEstado} className={styles.presupuestoBadge}>
          {labelEstado}
        </Badge>
      </div>
      <div className={styles.presupuestoBody}>
        {Number.isFinite(cantDiasEntrega) && (
          <span>
            <i className="fa fa-truck" aria-hidden="true" />
            <strong>Entrega:</strong> {cantDiasEntrega} día{cantDiasEntrega === 1 ? '' : 's'}
          </span>
        )}
        {fechaValidez && (
          <span>
            <i className="fa fa-calendar-o" aria-hidden="true" />
            <strong>Válido hasta:</strong> {formatearFecha(fechaValidez)}
          </span>
        )}
        {esPerfilAdmin && muestraNombreNoAdmin && (
          <span>
            <i className="fa fa-user bigger-icon mr-2" aria-hidden="true" />
            <strong>{esVentas ? 'Vendedor' : 'Comprador'}:</strong>{' '}
            {!esVentas ? nombreComprador : nombreVendedor}
          </span>
        )}
      </div>

      <div className={styles.infoContraparte}>
        <span>
          <i className="fa fa-user bigger-icon mr-2" aria-hidden="true" />
          {esVentas ? nombreComprador : nombreVendedor} - {razonSocial}
        </span>
        <LinkButton to={pathDetalle} className={styles.califButton}>
          <i className="fa fa-search" aria-hidden="true" />
          Ver Detalle
        </LinkButton>
      </div>
    </div>
  )
}

Presupuesto.propTypes = {
  presupuesto: PropTypes.shape({
    idPresupuesto: PropTypes.number.isRequired,
    idEstado: PropTypes.number.isRequired,
    estado: PropTypes.string.isRequired,
    titulo: PropTypes.string.isRequired,
    toggleOn: PropTypes.bool,
    ultimoMensaje: PropTypes.string,
    nombreComprador: PropTypes.string,
    nombreVendedor: PropTypes.string,
    cantDiasEntrega: PropTypes.number,
    fechaValidez: PropTypes.string,
    razonSocial: PropTypes.string,
    idUsuario: PropTypes.number,
    idVendedor: PropTypes.number
  }).isRequired,
  esVentas: PropTypes.bool.isRequired
}

export default Presupuesto
